export default __webpack_public_path__ + "static/media/background1.5aaa3dcc.png";